import React, { lazy } from "react";
import { useSelector } from "react-redux";
import {
  Redirect,
  Route,
  Switch,
  Router as ReactRouter,
} from "react-router-dom";
import history from "../services/browser.js";
import { Routes, RouteService } from "../services/route.service";
import ProtectedRoute from "./ProtectedRoute";
import ConnectedBuyPermitsPage from "../containers/Pages/ConnectedBuyPermitsPage";
import NotFound from "../components/Pages/404";
import RouteListener from "containers/Pages/RouteListener";

const HomePage = lazy(() =>
  import("../containers/Pages/ConnectedHomePage")
);
const LoginPage = lazy(() =>
  import("../containers/Pages/ConnectedLoginPage")
);
const ForgetPasswordPage = lazy(() =>
  import("../containers/Pages/ConnectedForgetPassword")
);
const SecurityPage = lazy(() =>
  import("../containers/Pages/ConnectedSecurityPage")
);
const ForgetUserName=lazy(()=>
import("../containers/Pages/ConnectedForgetUserName")
)
const DashboardPage = lazy(() =>
  import("../containers/Pages/ConnectedDashboardPage")
);
const verifyDashboard = lazy(() =>
  import("../containers/Pages/ConnectedVerifyDashboardPage")
);
const RegistrationPage = lazy(() =>
  import("../containers/Pages/ConnectedRegistrationPage")
);
const RegistrationSuccessPage = lazy(() =>
  import("../containers/Pages/ConnectedRegistrationSuccessPage")
);
const ResetPasswordPage = lazy(() =>
  import("../containers/Pages/ConnectedResetPasswordPage")
);
const ResetPasswordStatusPage = lazy(() =>
  import("../containers/Pages/ConnectedResetPasswordStatus")
);
const ResetuserNameStatusPage = lazy(() =>
  import("../containers/Pages/ConnectedResetUserStatusPage")
);
const PrivacyPage = lazy(() =>
  import("../containers/Pages/ConnectedPrivacyPage")
);
const PciCompliancePage = lazy(() =>
  import("../containers/Pages/ConnectedPciCompliancePage")
);
const PayCitationPage = lazy(() =>
  import("../containers/Pages/ConnectedPayCitationPage")
);
const ConnectedRestPaswordSuccessPage = lazy(() =>
  import("../containers/Pages/ConnectedResetPasswordSuccessPage")
);
const ConnectedProfilePage = lazy(() =>
  import("../containers/Pages/ConnectedProfilePage")
);
const ConnectedCitationPage = lazy(() =>
  import("../containers/Pages/ConnectedCitationPage")
);
const ConnectedPayCitationFormPage = lazy(() =>
  import("../containers/Pages/ConnectedPayCitationFormPage")
);
const ConnectedPayCitationDetailsPage = lazy(() =>
  import("../containers/Pages/ConnectedCitationDetailsPage")
);
const ConnectedCitationPaymentStatusPage = lazy(() =>
  import("../containers/Pages/ConnectedCitationPaymentStatusPage")
);
const ConnectedViewOrdersPage = lazy(() =>
  import("../containers/Pages/ConnectedViewOrdersPage")
);
const ConnectedVerifyEmailPage = lazy(() =>
  import("../containers/Pages/ConnectedVerifyEmailPage")
);
const ConnectedVisitorPermitPage = lazy(() =>
  import("../containers/Pages/ConnectedVisitorPermit")
);
const ConnectedVisitorPermitPageForm = lazy(() =>
  import("../containers/Pages/ConnectedVisitorPermitFormPage")
);
const ConnectedPermitPaymentStatusPage = lazy(() =>
  import("../containers/Pages/ConnectedPermitPaymentStatus")
);

const Router = () => {
  let loginStore = useSelector((state) => state["loginState"]);
  let homeStore = useSelector((state) => state["homeState"]);
  let isAuthenticated =
    loginStore.isAuthenticated &&
    loginStore.access_token &&
    loginStore.refresh_token;

  return (
    <ReactRouter history={history}>
      <RouteListener />
      <Switch>
        <Route exact path={Routes.ROOT} component={HomePage} />
        <Route
          exact
          path={Routes.FORGETPASSWORD}
          component={ForgetPasswordPage}
        />
        <Route
          exact
          path={Routes.FORGETUSERNAME}
          component={ForgetUserName}
        />
        <Route
          exact
          path={Routes.SECURITY}
          component={SecurityPage}
        />
        <Route exact path={Routes.LOGIN} component={LoginPage} />
        <Route
          exact
          path={Routes.REGISTRATION}
          component={RegistrationPage}
        />
        <Route
          exact
          path={Routes.RESETPASSWORD}
          component={ResetPasswordPage}
        />
        <Route
          exact
          path={Routes.RESETPASSWORDSTATUS}
          component={ResetPasswordStatusPage}
        />
        <Route exact path={Routes.RESETUSERNAMESTATUS} component={ResetuserNameStatusPage}/>
        <Route exact path={Routes.PRIVACY} component={PrivacyPage} />
        <Route
          exact
          path={Routes.PCICOMPLIANCE}
          component={PciCompliancePage}
        />
        <Route exact path={Routes.PAYCITATION} component={PayCitationPage} />
        <Route
          exact
          path={Routes.REGISTRATIONSUCCESS}
          component={RegistrationSuccessPage}
        />
        <Route
          exact
          path={Routes.RESETPASSWORDSUCCESS}
          component={ConnectedRestPaswordSuccessPage}
        />
        <Route
          exact
          path={Routes.PAYCITATIONFORMPAGE}
          component={ConnectedPayCitationFormPage}
        />
        <ProtectedRoute
          authorized={isAuthenticated}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.DASHBOARD}
          component={DashboardPage}
        />
        <ProtectedRoute
          authorized={isAuthenticated}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.VERIFYDASHBOARD}
          component={verifyDashboard}
        />
        <ProtectedRoute
          authorized={isAuthenticated}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.PROFILEPAGE}
          component={ConnectedProfilePage}
        />
        <ProtectedRoute
          authorized={isAuthenticated}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.CITATION}
          component={ConnectedCitationPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.viewOrders(
            homeStore.customerName
          )}
          exact
          path={Routes.VIEWORDERS}
          component={ConnectedViewOrdersPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.viewOrders(
            homeStore.customerName
          )}
          exact
          path={Routes.BUYPERMITS}
          component={ConnectedBuyPermitsPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.viewOrders(
            homeStore.customerName
          )}
          exact
          path={Routes.PERMIT_PAYMENT_STATUS}
          component={ConnectedPermitPaymentStatusPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.CITATIONDETAILS}
          component={ConnectedPayCitationDetailsPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.CITATIONPAYMENTSTATUS}
          component={ConnectedCitationPaymentStatusPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.VERIFYEMAIL}
          component={ConnectedVerifyEmailPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.VISITORPERMIT}
          component={ConnectedVisitorPermitPage}
        />
        <ProtectedRoute
          authorized={true}
          unauthorizedRedirect={RouteService.login(homeStore.customerName)}
          exact
          path={Routes.VISITORPERMITFORM}
          component={ConnectedVisitorPermitPageForm}
        />
        <Route
          exact
          path={Routes.INCOMPLETEPAYMENT}
          render={() =>
            isAuthenticated ? (
              <Redirect to={RouteService.dashboard(homeStore.customerName)} />
            ) : (
              <Redirect to={RouteService.home(homeStore.customerName)} />
            )
          }
        />
        <Route path="*" exact={true} component={NotFound} />
      </Switch>
    </ReactRouter>
  );
};
export default Router;
